<script>
import Loading from "@/components/layout/Loading.vue";
import SinResultados from "@/components/layout/SinResultados.vue";
import { mapState, mapActions } from "vuex";
import IconEncuestas from "@/assets/img/icon/section/IconEncuestas.vue";
export default {
  name: "Encuesta",
  components: {
    Loading,
    SinResultados,
    IconEncuestas,
  },
  data() {
    return {
      id_encuesta: [],
      default_color: "#fff",
      hovered_id: "",
      loadingEncuesta: true,
    };
  },
  computed: {
    ...mapState("EncuestaModule", [
      "paginacionTotalEncuestas",
      "listEncuestasActivas",
    ]),
  },
  created() {
    this.getEncuestaLista();
  },
  methods: {
    ...mapActions("EncuestaModule", [
      "getPaginasEncuestas",
      "getListaEncuestas",
    ]),
    async getEncuestaLista() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        limite: "99",
      };
      this.loadingEncuesta = true;
      await this.getPaginasEncuestas(data_).then((res) => {
        if (res) {
          this.id_encuesta = res[0].encuestas;
          data_ = {
            id_encuesta: this.id_encuesta,
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario,
          };
          this.getListaEncuestas(data_);
        }
      });
      this.loadingEncuesta = false;
    },
    updateHoverState(id_) {
      this.hovered_id = id_;
    },
  },
};
</script>

<template>
  <section id="encuestas">
    <div class="row">
      <div class="col-12 mb-0">
        <h1
          class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center"
        >
          <IconEncuestas class="me-2 icon-svg-45" />
          Encuestas
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home" class="color-main">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              <font-awesome-icon icon="fa-solid fa-square-check" ></font-awesome-icon>
                Encuestas
              </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Sé parte de nuestros procesos corporativos! Responde las siguientes
          encuestas y juntos mejoremos nuestro clima.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <Loading v-if="loadingEncuesta" pixeles="200px" />

        <SinResultados
          v-if="!loadingEncuesta && listEncuestasActivas.length === 0"
        />

        <div v-if="!loadingEncuesta" class="row">
          <div
            v-for="encuesta in listEncuestasActivas"
            :key="encuesta.id_encuesta"
            class="col-12 col-lg-4 mb-3"
          >
            <template v-if="encuesta.tipo_encuesta.id_tipo_encuesta == 1">
              <router-link
                class="card card-custom card-custom-border-hover card-shadow rounded-4 transition-all mh-120"
                :to="`/encuesta/${encuesta.id_encuesta}`"
              >
                <div
                  @mouseover="updateHoverState(encuesta.id_encuesta)"
                  @mouseleave="updateHoverState('')"
                  class="card-body"
                >
                  <div class="d-flex">
                    <div class="flex-shrink-0">
                      <font-awesome-icon icon="fa-solid fa-pen-to-square" class="h1 main-color" ></font-awesome-icon>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-secondary font-700 mb-0">
                        {{ encuesta.nombre_encuesta }}<br />
                        <span
                          class="text-secondary text-opacity-75 font-400 mb-0"
                        >
                          {{ encuesta.descripcion }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </router-link>
            </template>
            <template v-if="encuesta.tipo_encuesta.id_tipo_encuesta == 2">
              <a
                class="card card-custom card-custom-border-hover card-shadow rounded-4 transition-all mh-120"
                :href="encuesta.url_encuesta"
                target="_blank"
              >
                <div
                  @mouseover="updateHoverState(encuesta.id_encuesta)"
                  @mouseleave="updateHoverState('')"
                  class="card-body"
                >
                  <div class="d-flex">
                    <div class="flex-shrink-0">
                      <font-awesome-icon class="h1 fa-light fa-pen-to-square main-color" icon="fa-regular fa-pen-to-square" ></font-awesome-icon>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-secondary font-700 mb-0">
                        {{ encuesta.nombre_encuesta }}<br />
                        <span
                          class="text-secondary text-opacity-75 font-400 mb-0"
                        >
                          {{ encuesta.descripcion }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
